import Vue from 'vue'
import App from './App.vue'
import router from './router'

import storeInit from './store/'
import FlagIcon from 'vue-flag-icon'
import VueLogger from 'vuejs-logger'
import VueI18n from 'vue-i18n'
import en from './lang/en'
import de from './lang/de'
import fr from './lang/fr'
import nl from './lang/nl'
import sv from './lang/sv'
import tr from './lang/tr'
import ru from './lang/ru'
import ar from './lang/ar'
import pl from '@/lang/pl'
import uk from '@/lang/uk'
import it from '@/lang/it'

import * as actions from './store/action-types'
import {
  IconsPlugin,
  ButtonPlugin,
  ModalPlugin,
  LayoutPlugin,
  NavPlugin,
  TablePlugin,
  DropdownPlugin,
  CardPlugin,
  ButtonGroupPlugin,
  TooltipPlugin,
  CollapsePlugin
} from 'bootstrap-vue'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/de'
import 'dayjs/locale/nl'
import 'dayjs/locale/se'
import 'dayjs/locale/fr'
import 'dayjs/locale/uk'
import 'dayjs/locale/es'
import 'dayjs/locale/ru'
import 'dayjs/locale/tr'
import 'dayjs/locale/es'
import 'dayjs/locale/ar'
import 'dayjs/locale/pl'
import 'dayjs/locale/it'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from 'vuetify'

import { defaultLocale } from './app.config'
import VTooltip from 'v-tooltip'

const VueKeyCloak = () => import('@dsb-norge/vue-keycloak-js')
import { disableKeycloakAuthorization, keycloakConfig } from '@/app.config'

require('dotenv').config()
// Install BootstrapVue
Vue.use(ButtonPlugin)
Vue.use(ModalPlugin)
Vue.use(LayoutPlugin)
Vue.use(NavPlugin)
Vue.use(TablePlugin)
Vue.use(DropdownPlugin)
Vue.use(CardPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(CollapsePlugin)
Vue.use(TooltipPlugin)
Vue.use(IconsPlugin)
Vue.use(FlagIcon)
Vue.use(Vuetify)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)
Vue.filter('formatDate', function(value) {
  if (value) {
    return dayjs(String(value)).format('MM/DD/YYYY hh:mm')
  }
})

let storedLocaleLanguage = defaultLocale
let userLang = storedLocaleLanguage
if (process.env.VUE_APP_USE_USER_LOCALE === '1') {
  userLang = navigator.language || navigator.userLanguage
}

const isProduction = process.env.NODE_ENV === 'production'

const logOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}
Vue.use(VueLogger, logOptions)

Vue.use(VueI18n)

const messages = {
  en: en,
  de: de,
  fr: fr,
  nl: nl,
  sv: sv,
  uk: uk,
  es: en,
  tr: tr,
  pl: pl,
  ru: ru,
  ar: ar,
  it: it
}

Vue.use(VTooltip)
Vue.use(BootstrapVue)

Vue.config.productionTip = false

if (!(disableKeycloakAuthorization === '1')) {
  Vue.use(VueKeyCloak, {
    config: keycloakConfig,
    init: {
      onLoad: 'check-sso',
      enableLogging: false,
      silentCheckSsoRedirectUri:
        window.location.origin + '/silent-check-sso.html',
      checkLoginIframe: true,
      checkLoginIframeInterval: 5
    },
    onReady: k => {
      global.keycloak = k

      // listen to Single Sign-out, aka external logout events or expired sessions
      k.onAuthLogout = () => {
        window.location.reload()
      }

      const store = storeInit()
      store.commit(actions.SET_LANGUAGE, userLang)
      const i18n = new VueI18n({
        locale: store.state.language,
        fallbackLocale: 'en',
        messages: messages,
        dateTimeFormats: {
          en: {
            short: {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            },
            long: {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              weekday: 'short',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true
            }
          },
          de: {
            short: {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            },
            long: {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              weekday: 'short',
              hour: 'numeric',
              minute: 'numeric',
              hour12: false
            }
          }
        }
      })

      Vue.use(VueGoogleMaps, {
        load: {
          key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
          libraries: 'places',
          region: process.env.VUE_APP_GOOGLE_MAPS_DEFAULT_REGION || 'DE',
          language: store.state.locale
        }
      })

      new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
      }).$mount('#app')

      global.log = Vue.$log
    }
  })
} else {
  const store = storeInit()
  store.commit(actions.SET_LANGUAGE, userLang)
  const i18n = new VueI18n({
    locale: store.state.language,
    fallbackLocale: 'en',
    messages: messages,
    dateTimeFormats: {
      en: {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true
        }
      },
      de: {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false
        }
      }
    }
  })
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
  global.log = Vue.$log
}
